import React, { useRef } from 'react';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';

    const { FiSearch, FiX } = FiIcons;

    const SearchBar = ({ query, onQueryChange }) => {
      const inputRef = useRef(null);

      const handleSubmit = (e) => {
        e.preventDefault();
        // Search is handled via debounced changes, so submit can be a no-op.
      };

      const handleClear = () => {
        onQueryChange('');
        if (inputRef.current) {
          inputRef.current.focus();
        }
      };

      const handleChange = (e) => {
        onQueryChange(e.target.value);
      };

      return (
        <form onSubmit={handleSubmit} className="flex items-center gap-2">
          <div className="relative flex-1">
            <SafeIcon
              icon={FiSearch}
              className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 transform text-gray-400"
            />
            <input
              ref={inputRef}
              type="text"
              value={query}
              onChange={handleChange}
              placeholder="Search by name, nicknames, or notes..."
              className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-10 pr-3 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <button
            type="button"
            onClick={handleClear}
            disabled={!query}
            className="inline-flex items-center gap-1 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60"
            aria-label="Clear search"
          >
            <SafeIcon icon={FiX} />
            <span className="hidden sm:inline">Clear</span>
          </button>
        </form>
      );
    };

    export default SearchBar;